import Component from "../../lib/component";
import waveSvg from './assets/wave.svg';

export const WaveConfig = {
    componentTypeKey: 'Wave',
    baseHtmlClass: 'wavesbox__wave',
    selector: '.wavesbox__wave',
};

export class Wave extends Component {

    static createWaveElement(parentElement) {
        const element = document.createElement('span');
        element.classList.add(Wave.config.baseHtmlClass);
        parentElement.appendChild(element);
        return element;
    }

    static get config() {
        return WaveConfig;
    }

    constructor(id_or_element, wavesbox, options = {}) {
        super({
            element: id_or_element,
            config: Wave.config
        });

        this.wavesbox = wavesbox;

        this.renderInitial();
    }

    renderInitial() {
        if (this.isBlended()) this.addHtmlClassState('blended');
        // Add the image as an svg element into the DOM.
        const svgElement = this.getWaveSvgElement();
        this.element.appendChild(svgElement);
    }


    getWaveSvgElement() {
        const element = new DOMParser().parseFromString(waveSvg, "image/svg+xml").documentElement;
        const styles = "display:block; position:absolute; top:0; left:0; width:100%; height:100%;";
        element.cssText = styles;
        element.setAttribute('style', styles);
        return element;
    }

    isBlended() {
        return this.wavesbox.isBlended;
    }

}

function encodeSvgDataUri(svg) {
    // encodeURIComponent to make sure special characters don't break the URI
    return 'data:image/svg+xml,' + encodeURIComponent(svg);
}
